import { MenuItem, TextField } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthContext } from '../../../contexts/AuthContext';
import { identityRefreshTokenStart } from '../../../redux/identity/identitySlice';
import { RootState } from '../../../redux/store';
import { getCookieCustom } from '../../../utils/cookies';
import { getActiveDatabase, getDatabasesFromUser } from './utils';

const DatabaseSelector = () => {
	const dispatch = useDispatch();
	const { user } = useAuthContext();
	const { success } = useSelector((state: RootState) => state.identity);
	const [selectedDatabase, setSelectedDatabase] = useState<string>('');

	const databasesList = useMemo(() => getDatabasesFromUser(user), [user]);

	useEffect(() => {
		if (!user || !databasesList || databasesList.length === 0) {
			return;
		}

		const activeDatabaseId = getActiveDatabase(databasesList, user.currentlyActiveDb);
		setSelectedDatabase(activeDatabaseId);
	}, [user, databasesList]);

	useEffect(() => {
		if (success?.identityRefreshToken) {
			console.log('refresh token success');
			window.location.reload();
		}
	}, [success]);

	const handleDatabaseChange = (value: string) => {
		setSelectedDatabase(value);
		dispatch(
			identityRefreshTokenStart({
				refresh_token: getCookieCustom('refresh_token'),
				connectionKey: Number(value),
			}),
		);
	};

	if (databasesList.length === 0) {
		return null;
	}

	return (
		<TextField
			fullWidth
			select
			size="small"
			value={selectedDatabase}
			onChange={(event) => handleDatabaseChange(event.target.value)}
			sx={{ mb: '20px' }}
		>
			{databasesList.map((database) => (
				<MenuItem key={database.id} value={database.id}>
					{database.name}
				</MenuItem>
			))}
		</TextField>
	);
};

export default DatabaseSelector;
